import { create } from 'zustand';

interface DateRangeStore {
    dateRange: [string | null, string | null];
    setDateRanges: (range: [string | null, string | null]) => void;
}

const useDateRangeStore = create<DateRangeStore>((set: any) => ({
    dateRange: ['', ''], // Initial state
    setDateRanges: (range: any) => set({ dateRange: range }),
}));

export default useDateRangeStore;
